import Vue from "vue";
import Router from "vue-router";

const job = () => import("@/pages/job");
const home = () => import("@/pages/home");
const resume = () => import("@/pages/resume");
const about = () => import("@/pages/about");
const single = () => import("@/pages/single");
const profile = () => import("@/pages/profile");
const stores = () => import("@/pages/stores");
const innerStore = () => import("@/pages/innerStore");
const products = () => import("@/pages/products");
const category = () => import("@/pages/category");
const favorites = () => import("@/pages/favorites");
const contactus = () => import("@/pages/contactus");
const complaint = () => import("@/pages/complaint");
const NotFound = () => import("@/components/NotFound");
const representation = () => import("@/pages/representation");

Vue.use(Router);

export default new Router({
    mode: "history",
    scrollBehavior (to, from, savedPosition) {
        document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    },
    linkActiveClass: "is-active",
    routes: [
        {
            path: "/",
            name: "home",
            component: home,
            meta: {
                title: "کلانا | صفحه اصلی",
                header: true,
                footer: true,
            },
        },
        {
            path: "/job",
            name: "job",
            component: job,
            meta: {
                title: "کلانا | فرصت های شغلی",
                header: true,
                footer: true,
            },
        },
        {
            path: "/resume",
            name: "resume",
            component: resume,
            meta: {
                title: "کلانا | فرصت های شغلی",
                header: true,
                footer: true,
            },
        },
        {
            path: "/about",
            name: "about",
            component: about,
            meta: {
                title: "کلانا | درباره ما",
                header: true,
                footer: true,
            },
        },
        {
            path: "/representation",
            name: "representation",
            component: representation,
            meta: {
                title: "کلانا | اخذ نمایندگی",
                header: true,
                footer: true,
            },
        },
        {
            path: "/complaint",
            name: "complaint",
            component: complaint,
            meta: {
                title: "کلانا | ثبت نظر، تخلف و پیشنهاد",
                header: true,
                footer: true,
            },
        },
        {
            path: "/contact",
            name: "contactus",
            component: contactus,
            meta: {
                title: "کلانا | تماس با ما",
                header: true,
                footer: true,
            },
        },
        {
            path: "/products",
            name: "products",
            component: products,
            meta: {
                title: "کلانا | محصولات",
                header: true,
                footer: true,
            },
        },
        {
            path: "/innerStore",
            name: "innerStore",
            component: innerStore,
            meta: {
                title: "کلانا | اطلاعات فروشگاه",
                header: true,
                footer: true,
            },
        },
        {
            path: "/category",
            name: "category",
            component: category,
            meta: {
                title: "کلانا | دسته بندی محصولات",
                header: true,
                footer: true,
            },
        },
        {
            path: "/favorites",
            name: "favorites",
            component: favorites,
            meta: {
                title: "کلانا | مورد علاقه",
                header: true,
                footer: true,
            },
        },
        {
            path: "/single",
            name: "single",
            component: single,
            meta: {
                title: "کلانا | اطلاعات محصول",
                header: true,
                footer: true,
            },
        },
        {
            path: "/profile",
            name: "profile",
            component: profile,
            meta: {
                title: "کلانا | حساب کاربری",
                header: true,
                footer: true,
            },
        },
        {
            path: "/stores",
            name: "stores",
            component: stores,
            meta: {
                title: "کلانا | فروشگاه ها",
                header: true,
                footer: true,
            },
        },
        {
            path: "*"
            , component: NotFound
            , meta: {
                title: "کلانا | صفحه مورد نظر یافت نشد",
                header: false,
                footer: false,
            },
        }
    ],
});
